export default __webpack_public_path__ + "images/XY.2d838c5.png";